import React from 'react';

export type BusinessType = 'mill' | 'vehicle';

interface BusinessTypeTabsProps {
  activeType: BusinessType;
  onTypeChange: (type: BusinessType) => void;
  className?: string;
}

/**
 * Level 1 Navigation: Business Type Selection (Mill/Vehicle)
 * Simple horizontal tabs with monogram icons
 */
const BusinessTypeTabs: React.FC<BusinessTypeTabsProps> = ({
  activeType,
  onTypeChange,
  className = ''
}) => {
  const tabs: { type: BusinessType; label: string; monogram: string; color: string }[] = [
    {
      type: 'mill',
      label: 'Mill Operations',
      monogram: 'M',
      color: 'blue'
    },
    {
      type: 'vehicle',
      label: 'Vehicle Fleet',
      monogram: 'V',
      color: 'green'
    }
  ];

  return (
    <div className={`border-b border-border-default ${className}`}>
      <nav className="flex -mb-px space-x-8" aria-label="Business Type">
        {tabs.map((tab) => {
          const isActive = activeType === tab.type;
          
          return (
            <button
              key={tab.type}
              type="button"
              onClick={() => onTypeChange(tab.type)}
              className={`
                group inline-flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm
                ${isActive
                  ? 'border-ds-primary-500 text-ds-primary-600'
                  : 'border-transparent text-text-muted hover:text-text-secondary hover:border-border-muted'
                }
              `}
              aria-current={isActive ? 'page' : undefined}
            >
              {/* Monogram Icon */}
              <span
                className={`
                  flex items-center justify-center w-6 h-6 rounded text-xs font-bold
                  ${isActive
                    ? `bg-${tab.color}-100 text-${tab.color}-700`
                    : `bg-bg-subtle text-text-secondary group-hover:bg-bg-muted`
                  }
                `}
              >
                {tab.monogram}
              </span>
              
              {/* Label */}
              <span>{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default BusinessTypeTabs;
